import { render, staticRenderFns } from "./cabinDetail.vue?vue&type=template&id=756209fa&"
import script from "./cabinDetail.vue?vue&type=script&lang=js&"
export * from "./cabinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756209fa')) {
      api.createRecord('756209fa', component.options)
    } else {
      api.reload('756209fa', component.options)
    }
    module.hot.accept("./cabinDetail.vue?vue&type=template&id=756209fa&", function () {
      api.rerender('756209fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/cabinManagement/cabinDetail.vue"
export default component.exports